'use client';
import { jsx } from 'react/jsx-runtime';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { ListboxPopover } from '../listbox/listbox-popover.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { className } from '../../../core/utilities/classnames.utils.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t.push.apply(t, o);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
const ComboboxPopover = renderWithRef('ComboboxPopover', null, (t, c)=>{
    useDeprecatedProps('ComboboxPopover', t, [
        {
            propName: 'labelText',
            instructions: 'This is deprecated without a replacement.'
        }
    ]);
    let { children: p, placement: s = 'bottom start', className: i } = t;
    return jsx(ListboxPopover, _object_spread_props(_object_spread({
        className: className(i, 'swan-combobox-popover')
    }, t), {
        placement: s,
        ref: c,
        isNonModal: true,
        children: p
    }));
});

export { ComboboxPopover };
